import httpService from '@/helper/httpService';
import store from '@/store';

const RELOAD_KEY = 'frontend_version_reload_attempted';

/**
 * Prüft die Frontend-Version gegen den Server und löst ggf. einen Reload aus
 * @param frontendVersion 
 * @return {Promise<Object>} - Object: { ok: bool, requestversion: String, compareversion: String, status: String }
 */
export async function checkServerFrontendVersion(frontendVersion) {
  if (!frontendVersion) {
    console.log("Keine Frontend-Version übergeben. Version-Check übersprungen.");
    return { ok: true, requestversion: frontendVersion };
  }

  // Debug-Version aus Store hat Vorrang
  let versionToCheck = frontendVersion;
  const debugVersion = store.state.env?.debugFrontendVersion;
  if (debugVersion) {
    versionToCheck = debugVersion;
    console.log('Debug: Verwende Debug-Version:', debugVersion, '(Original:', frontendVersion, ')');
  }
  const result = await httpService.getServerVersion(versionToCheck);
  
  if (result && !result.ok) {
    // Prüfen, ob bereits ein Reload-Versuch gemacht wurde
    if (sessionStorage.getItem(RELOAD_KEY)) {
      console.error('Version-Mismatch nach Reload. Server:', result.compareversion, 'Client:', result.requestversion);
      return result;
    }

    // Prüfen ob Benutzer eingeloggt ist
    let isLoggedIn = false;
    try {
      await httpService.getWhoAmI();
      isLoggedIn = true;
    } catch (error) {
      // Nicht eingeloggt (401 oder anderer Fehler)
      isLoggedIn = false;
    }
    
    // Benutzer informieren und bestätigen lassen
    const message = 'Eine neue Version der Maklerportal Anwendung ist verfügbar.\n\n' +
                    'Um die neueste Version zu nutzen, muss die Seite neu geladen werden.\n' +
                    'Nicht gespeicherte Änderungen gehen dabei verloren.\n\n' +
                    'Sie können z.B. durch <Strg>+<F5> auch selbst neu laden.\n\n' +
                    'Jetzt neu laden?';
    
    let userConfirmed = false;
    if (isLoggedIn) {
      userConfirmed = confirm(message);
    }

    if (userConfirmed || !isLoggedIn) {
      // Markieren und neu laden
      sessionStorage.setItem(RELOAD_KEY, 'true');
      console.log('Neue Frontend-Version verfügbar. Lade neu...');
      window.location.reload();
    } else {
      // Benutzer hat abgelehnt - merken, dass neue Version verfügbar ist
      sessionStorage.setItem('frontend_version_outdated', result.compareversion);
    }
  } else {
    // Bei erfolgreicher Prüfung Flags entfernen
    sessionStorage.removeItem(RELOAD_KEY);
    sessionStorage.removeItem('frontend_version_outdated');
  }
  
  return result;
}

/**
 * Setzt eine zufällige Frontend-Version für Test-Zwecke
 * Diese wird im Store gespeichert und überschreibt die echte Version
 */
export function setRandomFrontendVersion() {
    const randomVersion = `${Math.floor(Math.random() * 24).toString().padStart(2, '0')}-${Math.floor(Math.random() * 60).toString().padStart(2, '0')}-${Math.floor(Math.random() * 60).toString().padStart(2, '0')}`;
    store.commit('setObject', { env: { versioninfo: randomVersion } });
    console.log('Debug: Frontend-Version gesetzt auf:', randomVersion);
}

/**
 * Setzt die Frontend-Version auf die Server-Version für Test-Zwecke
 * @return {Promise<string>} - Die gesetzte Version
 */
export async function setFrontendVersionToServerVersion() {
    try {
        // Hole aktuelle Version vom Server
        const dummyVersion = '00-00-00';
        const result = await httpService.getServerVersion(dummyVersion);

        if (result && result.compareversion) {
            store.commit('setObject', { env: { versioninfo: result.compareversion } });
            console.log('Debug: Frontend-Version synchronisiert mit Server-Version:', result.compareversion);
            return result.compareversion;
        } else {
            console.error('Debug: Konnte Server-Version nicht abrufen');
            return null;
        }
    } catch (error) {
        console.error('Debug: Fehler beim Abrufen der Server-Version:', error);
        return null;
    }
}
